import * as React from 'react';
import Lottie from 'react-lottie';
import * as animationData from '../../lotties/lesson_complete.json';
import { css } from 'aphrodite';
export const LessonCompleteAnimationIcon = ({ classObject, loop, onFinish }) => {
    const options = {
        loop: loop !== null && loop !== void 0 ? loop : false,
        animationData: animationData,
    };
    const eventListeners = [
        {
            eventName: 'complete',
            callback: onFinish,
        },
    ];
    return (React.createElement("div", { className: css(classObject) },
        React.createElement(Lottie, { options: options, eventListeners: eventListeners })));
};
